module.exports = __webpack_public_path__ + "static/media/BML.29643445.png";